module.exports = __webpack_public_path__ + "img/boiler-N-light.7cc2a65d.png";